import React, { useState } from 'react'
import Slider from 'react-slick'
import useStyles, { FormInputSelect } from './styles'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Section from '../../components/Section/Section'
import Footer from '../../components/Footer/Footer'
import FormInputNoLabel from '../../components/FormInputNoLabel/FormInputNoLabel'
import Paragraph from '../../components/Typography/Paragraph'
import Card from '../../components/Card/Card'
import Loader from 'react-js-loader'

import giftbox from '../../assets/images/giftbox.png'
import wallet from '../../assets/images/wallet.png'
import slot from '../../assets/images/slot.png'
import result from '../../assets/images/result.png'
import event from '../../assets/images/event.png'
import subscribe from '../../assets/images/subscribe.png'

import {
    Container,
    Grid,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Collapse,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    RadioGroup,
    Radio,
    FormControlLabel,
    TablePagination,
    Stack,
    Checkbox,
    Autocomplete
} from '@mui/material'
import Button from '../../components/Button/Button'
import {
    MoreVert,
    AddCircle,
    RemoveCircle,
    ArrowCircleDown,
    ArrowCircleUp,
    SubdirectoryArrowRight,
    Close,
    SignalCellularNullRounded
} from '@mui/icons-material'
import {
    get_customer_detail,
    get_customer_contact,
    get_inventory_by_customer,
    create_orders_admin,
    validate_cart_admin,
    get_class,
    change_admin_password
} from '../../API/API'
import Countdown from 'react-countdown'
import moment from 'moment/moment'

import './styles.css'
import FormInput from '../../components/FormInput/FormInput'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import toast from 'react-simple-toasts'
import useUser from '../../hooks/useUser'

export default function Setting() {
    const classes = useStyles()
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()

    const {
        set_user,
        get_user
    } = useUser();

    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState({
        old_password: "",
        password: "",
        password2: "",
        admin_id: "",
    })

    const handleChange = (e) => {
        setPassword({
            ...password,
            [e.target.name]: e.target.value,
        });
    };

    const handleChangePassword = () => {
        if (password.old_password.length === 0) {
            toast("Please enter old password")
            return
        }
        if (password.password.length === 0) {
            toast("Please enter new password")
            return
        }
        if (password.password2.length === 0) {
            toast("Please enter new confirm password")
            return
        }
        var data = {
            ...password,
            admin_id: get_user().admin_id
        }
        change_admin_password(data).then((json) => {
            if (json.status) {
                toast('Password Changed')
            } else {
                toast(json.message);
            }
        });
        // if (loginData.email.length == "" || loginData.password.length == "") {
        //   alert("All Field Required");
        //   return;
        // }

        // login(loginData).then((json) => {
        //   if (json.status) {
        //     alert(json.message);
        //     navigate("/dashboard");
        //   } else {
        //     alert(json.message);
        //   }
        // });
    };

    return (
        <React.Fragment>
            {loading ? (
                <div style={{ margin: 'auto' }}>
                    <Loader type='bubble-loop' bgColor='#1A5386' size={50} />
                </div>
            ) : (
                <React.Fragment>

                    <Navbar2
                        children={
                            <Section pd='2rem'>
                                <div>
                                    {/* <div
                                        onClick={() => navigate(-1)}
                                        style={{
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <Paragraph
                                            color='#1A5386'
                                            bold='400'
                                            size='12px'
                                            margin='0 0 1rem'
                                        >
                                            &lt; Back
                                        </Paragraph>
                                    </div> */}
                                    <div className={classes.theFlexHeader}>
                                        {/* <div className={classes.theHeaderSelect}>
                            <FormInput
                                // label="Username"f
                                textLabelColor="#000"
                                // placeholder="Username"
                                // name="username"
                                bold="600"
                                border="0"
                                size="24px"
                                value={location.pathname.replace(/[^A-Za-z]+/g, "")}
                                select
                                onChange={handleHeader}
                            >
                                <MenuItem value="sale">Sale Order</MenuItem>
                                <MenuItem value="invoice">Invoice</MenuItem>
                            </FormInput>
                        </div> */}
                                        <Paragraph color='#1A5386' bold='600' size='24px'>
                                            Change Setting
                                        </Paragraph>

                                        {/* <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                                            <a
                                                className={classes.theCustomActionBtnFill}
                                            // onClick={() => handleOpenStockMove()}
                                            >
                                                <CheckCircleOutline sx={{ color: "#fff" }} />
                                                <Paragraph margin="0 0 0 .4rem">Approve</Paragraph>
                                            </a>
                                            <a
                                                className={classes.theCustomActionBtnFill_}
                                            // onClick={() => handleOpenStockMove()}
                                            >
                                                <DoDisturbAlt sx={{ color: "#fff" }} />
                                                <Paragraph margin="0 0 0 .4rem">Reject</Paragraph>
                                            </a>
                                        </div> */}
                                    </div>
                                    <div
                                        style={{
                                            borderBottom: '2px solid #707070',
                                            padding: '.2rem 0'
                                        }}
                                    />
                                    <br />
                                    <Card className={classes.theCard_}>
                                        <div className={classes.theCHeader}>
                                            <Paragraph
                                                color="#000"
                                                bold="600"
                                                size="16px"
                                            // margin="0 0 1rem"
                                            >
                                                Security
                                            </Paragraph>
                                        </div>
                                        <div className={classes.theCBody}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <FormInput
                                                        label='Old Password*'
                                                        textcolor='#707070'
                                                        placeholder='Old Password'
                                                        name='old_password'
                                                        bg='#fff'
                                                        border='1px solid #c5c5c5'
                                                        type="password"
                                                        onChange={handleChange}
                                                    >
                                                    </FormInput>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <FormInput
                                                        label='New Password*'
                                                        textcolor='#707070'
                                                        placeholder='Old Password'
                                                        name='password'
                                                        bg='#fff'
                                                        border='1px solid #c5c5c5'
                                                        type="password"
                                                        onChange={handleChange}
                                                    >
                                                    </FormInput>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <FormInput
                                                        label='Confirm New Password*'
                                                        textcolor='#707070'
                                                        placeholder='Confirm New Password'
                                                        name='password2'
                                                        bg='#fff'
                                                        border='1px solid #c5c5c5'
                                                        type="password"
                                                        onChange={handleChange}
                                                    >
                                                    </FormInput>
                                                </Grid>
                                            </Grid>
                                            <br />
                                            <div
                                                className={classes.theFlexBtn}
                                                style={{ marginBottom: '0' }}
                                            >
                                                <a
                                                    className={classes.theAddCustomActionBtnFill}
                                                    onClick={() => handleChangePassword()}
                                                >
                                                    {/* <CheckCircleOutline sx={{ color: "#fff" }} /> */}
                                                    <Paragraph margin='0 0 0 .4rem'>Save</Paragraph>
                                                </a>
                                                {/* <a
                                        className={classes.theCustomActionBtnFill_}
                                    // onClick={() => handleOpenStockMove()}
                                    >
                                        <DoDisturbAlt sx={{ color: "#fff" }} />
                                        <Paragraph margin="0 0 0 .4rem">Reject</Paragraph>
                                    </a> */}
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </Section>
                        }
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    )
}
